const defaultConfig = {
  titleKey: "benefits_title",
  itemsKey: "benefits_items",
};

/**
 *
 * @param page
 * @param config
 * @param props
 * @returns {{component: string, props}|null}
 */
export const benefits = ({ page, config, ...props }) => {
  config = Object.assign({}, defaultConfig, config);

  if (!page || !(config.itemsKey in page) || page[config.itemsKey].length === 0) {
    return null;
  }

  return {
    component: "Benefits",
    props: {
      title: page[config.titleKey] ?? null,
      items: page[config.itemsKey].map((i) => ({
        title: i.title ?? null,
        text: i.text ?? null,
        icon: i.icon ?? null,
      })),
      ...props,
    },
  };
};
